// eslint-disable-next-line import/prefer-default-export
export const ExportActions = Object.freeze({
    ExportManager: 0,
    ExportEmployee: 1,
});
